import { createReducer } from 'pobble-components/dist/redux-helpers'

let defaultState = {
  id: null,
  opened: false
}

const UpdateGroupDialog = createReducer(defaultState, {
  'GROUPS:UPDATE_GROUP_DIALOG:OPEN': (state, { id }) => ({
    ...state,
    opened: true,
    id
  }),
  'GROUPS:UPDATE_GROUP_DIALOG:CLOSE': state => ({ ...state, opened: false }),
  'GROUPS_STORE:UPDATE_REQUEST': state => ({ ...state, opened: false })
})

export default UpdateGroupDialog
